import { answer_me_config } from "./answer-me/answer_me_config";
import { picabook_config } from "./picabook/picabook_config";
import { tegra_config } from "./tegra/tegra_config";
import { carmark_config } from "./carmark/carmark_config";
import { practice_stop_config } from "./practice-stop/practice_stop_config";
import { mix_max_config } from "./mix-max/mix_max_config";
import { city_unlock_config } from "./city-unlock/city_unlock_config";
import { thaw_config } from "./thaw/thaw_config";

export const apps = [
  picabook_config,
  carmark_config,
  mix_max_config,
  city_unlock_config,
  thaw_config,
  practice_stop_config,
  answer_me_config,
  tegra_config,
];